import React, { useState, useEffect } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import axios from 'axios';
import userPlaceholder from '../../assets/image 1.png';
import Cookies from 'js-cookie';
const TeachersDetails = () => {
  const [teacherDetails, setTeacherDetails] = useState(null);

  useEffect(() => {
    fetchTeacherDetails();
  }, []);

  const fetchTeacherDetails = async () => {
    try {
      const response = await axios.get(`http://localhost:4000/api/v1/admin/getTeacher?Id=${Cookies.get('uId')}`);
      setTeacherDetails(response.data);
    } catch (error) {
      console.error('Error fetching teacher details:', error);
      alert('Failed to fetch teacher details. Please check the server logs.');
    }
  };

  if (!teacherDetails) {
    return <div>Loading...</div>;
  }

  return (
    <Container>
      <h4 className="title">Teachers Details</h4>
      <div
        style={{
          width: '60%',
          height: '100%',
          margin: 'auto',
          borderRadius: '10px',
          boxShadow: 'rgba(0, 0, 0, 0.35) 0px 5px 15px',
        }}
      >
        <Row style={{ padding: '5% 10%' }}>
          <Col lg={4} md={4} sm={12}>
            <div style={{ marginBottom: '10px' }}>
              <strong style={{ color: 'var(--primary)' }}>Name:</strong>
            </div>
            <div style={{ marginBottom: '20px' }}>{teacherDetails.Name}</div>

            <div style={{ marginBottom: '10px' }}>
              <strong style={{ color: 'var(--primary)' }}>Username:</strong>
            </div>
            <div style={{ marginBottom: '20px' }}>{teacherDetails.Username}</div>

            <div style={{ marginBottom: '10px' }}>
              <strong style={{ color: 'var(--primary)' }}>Contact:</strong>
            </div>
            <div style={{ marginBottom: '20px' }}>{teacherDetails.Contact}</div>

            <div style={{ marginBottom: '10px' }}>
              <strong style={{ color: 'var(--primary)' }}>Department:</strong>
            </div>
            <div style={{ marginBottom: '20px' }}>N/A</div>

            <div style={{ marginBottom: '10px' }}>
              <strong style={{ color: 'var(--primary)' }}>CV:</strong>
            </div>
            <div style={{ marginBottom: '20px' }}>
              <a href={`http://localhost:4000/${teacherDetails.cv}`} target="_blank" rel="noopener noreferrer">Download</a>
            </div>
          </Col>
          <Col lg={4} md={4} sm={12}>
            <div style={{ marginBottom: '10px' }}>
              <strong style={{ color: 'var(--primary)' }}>Surname:</strong>
            </div>
            <div style={{ marginBottom: '20px' }}>{teacherDetails.Surname}</div>

            <div style={{ marginBottom: '10px' }}>
              <strong style={{ color: 'var(--primary)' }}>Email:</strong>
            </div>
            <div style={{ marginBottom: '20px' }}>{teacherDetails.Email}</div>

            <div style={{ marginBottom: '10px' }}>
              <strong style={{ color: 'var(--primary)' }}>Institute:</strong>
            </div>
            <div style={{ marginBottom: '20px' }}>{teacherDetails.Institute}</div>

            <div style={{ marginBottom: '10px' }}>
              <strong style={{ color: 'var(--primary)' }}>Country:</strong>
            </div>
            <div style={{ marginBottom: '20px' }}>{teacherDetails.Country}</div>

            <div style={{ marginBottom: '10px' }}>
              <strong style={{ color: 'var(--primary)' }}>Level of Education:</strong>
            </div>
            <div style={{ marginBottom: '20px' }}>{teacherDetails.EducationalLevel}</div>
          </Col>
          <Col lg={4} md={4} sm={12} className="d-flex justify-content-center align-items-center" style={{ height: 'auto' }}>
            <img
              src={teacherDetails.ProfilePicture ? `http://localhost:4000/${teacherDetails.ProfilePicture}` : userPlaceholder}
              alt="Profile"
              className="img-circle"
              style={{
                width: '70px',
                height: '70px',
                borderRadius: '50%',
                objectFit: 'cover',
              }}
            />
          </Col>
        </Row>
        <Row style={{ padding: '5% 10%' }}>
          <Col sm={12}>
            <div style={{ marginBottom: '10px' }}>
              <strong style={{ color: 'var(--primary)' }}>Motivation:</strong>
            </div>
            <div style={{ marginBottom: '20px' }}>
              {teacherDetails.motivation}
            </div>
          </Col>
        </Row>
      </div>
    </Container>
  );
};

export default TeachersDetails;
